var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from '../utils/logger';
import { performAxiosRequest } from './requestHelper';
import { getCompanyInfo, postSendMailResetPassword, postUserLogin, postUserRegistration, postUserResetPassword, postValidatePassword, postValidateResetPaswordToken, } from './signoAPI';
export const submitUserLogin = (body) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postUserLogin(body);
        log.debug('[User service] GET login - response.status ==> ', response.status);
        return response.status === 200 ? response.data : null;
    }), [400, 401, 423], // Manejar estos errores
    (error) => (error === 423 ? error : false));
});
export const submitUserRegistration = (body) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postUserRegistration(body);
        log.debug('[User service] POST registration - response.status ===> ', response.status);
        return response.status === 200 ? response.data : null;
    }), [400, 403, 406], (error) => (error === 406 ? error : false));
});
export const submitResetPassword = (body, token) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postUserResetPassword(body, token);
        log.debug('[User service] POST reset password - response.status ===> ', response.status);
        return response.status === 200;
    }), [400, 404, 403], false);
});
export const doPasswordValidation = (password) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postValidatePassword(password);
        log.debug('[User service] POST validate password - response.status ===> ', response.status);
        return response.status === 200 && response.data;
    }), [400, 403, 406], false);
});
export const sendMailResetPassword = (userName) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postSendMailResetPassword(userName);
        return response.status === 200 && response.data;
    }), [400, 403, 406], {
        value: false,
        message: 'Error en el envío',
        responseStatus: 500,
    });
});
export const validateResetPaswordToken = (resetPasswordToken) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield postValidateResetPaswordToken(resetPasswordToken);
        return response.status === 200 && response.data.value;
    }), [400, 403, 406], false);
});
export const fetchCompanyInfo = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getCompanyInfo(companyId);
        log.debug('[User service] GET company info - response.status ===> ', response.status);
        return response.status === 200 && response.data;
    }));
});
// export const fetchUserprofile = async (companyId: number) => {
//   return performAxiosRequest(async () => {
//     const response: AxiosResponse = await getUserProfile(companyId);
//     log.debug('[User service] GET user Profile - response.status ===> ', response.status);
//     return response.status === 200 && response.data;
//   });
// };
// export const fetchUserprofileWithoutUserToken = async (companyId: number) => {
//   return performAxiosRequest(async () => {
//     const response: AxiosResponse = await getUserProfileBackOffice(companyId);
//     log.debug('[User service] GET user Profile - response.status ===> ', response.status);
//     return response.status === 200 && response.data;
//   });
// };
